import { useI18n } from 'hooks/useI18n';
import { UIOfferSection } from 'interfaces/ui/ui-offer-section';
import { Link } from 'react-scroll';
import { Heading4 } from '../../shared/Typography';
import { StyledOfferBottomBarPageNav } from './OfferBottomBarPageNav.styled';

const OfferBottomBarPageNav = ({
  sections,
  togglePageNav
}: {
  sections?: UIOfferSection[];
  togglePageNav: () => void;
}) => {
  const { t } = useI18n('job-offer');

  return (
    <StyledOfferBottomBarPageNav>
      <Heading4>{t('footer.bottomBar.index')}</Heading4>
      <ul>
        {sections?.map((s, i) => (
          <li key={i}>
            <Link
              activeClass="is-active"
              to={s.section || ''}
              spy={true}
              onClick={togglePageNav}
            >
              {s.tooltip}
            </Link>
          </li>
        ))}
      </ul>
    </StyledOfferBottomBarPageNav>
  );
};

export default OfferBottomBarPageNav;
